import React, { createContext, useContext, useEffect, useRef, useState, useMemo } from "react";

import { io, Socket } from "socket.io-client";

interface SocketContextType {
    socket: Socket | null;
}

export const SocketContext = createContext<SocketContextType>({
    socket: null,
});

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
    const [socket, setSocket] = useState<Socket | null>(null);
    const socketRef = useRef<Socket | null>(null);

    useEffect(() => {
        const chatSocketEndPoint = process.env.REACT_APP_API_URL__IMM_COMMUNICATION_HUB__SOCKET ? process.env.REACT_APP_API_URL__IMM_COMMUNICATION_HUB__SOCKET + '/chats' : '';
        const socketInstance = io(chatSocketEndPoint, {
            transports: ['websocket'],
        });

        socketRef.current = socketInstance;
        setSocket(socketInstance);

        socketInstance.on('connect', () => {
            console.log('✅ Connected to socket.io');
        });
        socketInstance.on('reconnect', () => {
            console.log('✅ Reconnected to socket.io');
        });

        socketInstance.on('disconnect', () => console.log('❌ Disconnected from socket.io'));
        socketInstance.on('connect_error', (err) => console.error(`Socket.io connection error: ${err.message}`, err));

        return () => {
            socketInstance.disconnect();
        };
    }, []);

    const socketValue = useMemo(() => ({ socket }), [socket]);

    return (
        <SocketContext.Provider value={socketValue} >
            {children}
        </SocketContext.Provider>
    );
};